import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm3.62 6.38a.876.876 0 0 0-1.24 0L12 10.763 9.62 8.38a.876.876 0 0 0-1.24 1.238L10.763 12 8.38 14.38a.876.876 0 0 0 1.238 1.24L12 13.237l2.38 2.381a.876.876 0 0 0 1.24-1.238L13.237 12l2.381-2.38a.876.876 0 0 0 0-1.24Z"
      clip-rule="evenodd"
    />
  </svg>
`;
